//import Vue from 'vue'
import Vue from 'vue/dist/vue.js'
import App from './App.vue'
import router from './router'
import firebase from 'firebase'
import VueFire from 'vuefire'
import Vuex from 'vuex'
import { store } from './store/store'
import VeeValidate from 'vee-validate'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import AsyncComputed from 'vue-async-computed'
import ToggleButton from 'vue-js-toggle-button'

import 'normalize.css'
import './firebase'

Vue.config.productionTip = false

Vue.use(VueFire)
Vue.use(Vuex)
Vue.use(VeeValidate)
Vue.use(VueMoment, { moment })
Vue.use(AsyncComputed)
Vue.use(ToggleButton)

var _ = require('lodash');

let app

firebase.auth().onAuthStateChanged(function() {
  console.log("autti vaihtui")
  if (!app) {
    app = new Vue({
      render: h => h(App),
      router,
      store,
    }).$mount('#app')
  }
})
